/* Sprivat — theme JS */
(function(){
  'use strict';

  // Year in footer
  document.querySelectorAll('[data-year]').forEach(function(el){ el.textContent = new Date().getFullYear(); });

  // Mobile menu
  var menu = document.getElementById('mobileMenu');
  if (menu){
    var open = document.getElementById('menuOpen');
    var close = document.getElementById('menuClose');
    function setOpen(v){
      menu.classList.toggle('is-open', v);
      menu.setAttribute('aria-hidden', String(!v));
      document.body.style.overflow = v ? 'hidden' : '';
    }
    if (open) open.addEventListener('click', function(){ setOpen(true); });
    if (close) close.addEventListener('click', function(){ setOpen(false); });
    menu.querySelectorAll('nav > a').forEach(function(a){
      a.addEventListener('click', function(){ setOpen(false); });
    });
  }

  // Hero carousel
  var track = document.getElementById('heroTrack');
  if (track){
    var dots = Array.prototype.slice.call(document.querySelectorAll('.hero__dot'));
    var prev = document.getElementById('heroPrev');
    var next = document.getElementById('heroNext');
    var total = track.children.length;
    var i = 0, timer;
    function go(n){
      i = (n + total) % total;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx === i); });
    }
    function auto(){ timer = setInterval(function(){ go(i + 1); }, 6000); }
    function stop(){ clearInterval(timer); }
    dots.forEach(function(d){
      d.addEventListener('click', function(){ stop(); go(parseInt(d.dataset.i, 10)); auto(); });
    });
    if (prev) prev.addEventListener('click', function(){ stop(); go(i - 1); auto(); });
    if (next) next.addEventListener('click', function(){ stop(); go(i + 1); auto(); });
    var sx = 0, dx = 0;
    track.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; dx = 0; stop(); }, { passive: true });
    track.addEventListener('touchmove',  function(e){ dx = e.touches[0].clientX - sx; }, { passive: true });
    track.addEventListener('touchend',   function(){ if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); auto(); });
    if (total > 1) auto();
  }

  // PDP gallery
  var galleryMain = document.getElementById('galleryMain');
  if (galleryMain){
    var thumbs = document.querySelectorAll('.gallery__thumb');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        thumbs.forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-src');
        var alt = t.getAttribute('data-alt') || '';
        if (src){
          galleryMain.innerHTML = '<img src="' + src + '" alt="' + alt + '" />';
        }
      });
    });
  }

  // Custom name + number text input — auto-shown when the selected variant
  // has any option value containing "Custom", or always shown if the product
  // is tagged 'allows-customization' (data-always-show="true" on the wrapper).
  function syncCustomText(){
    var box = document.querySelector('.opt-custom-text');
    if (!box) return;
    var alwaysShow = box.getAttribute('data-always-show') === 'true';
    var hasCustomOption = false;
    document.querySelectorAll('[data-option-row] .chip.is-active').forEach(function(b){
      var v = (b.getAttribute('data-value') || '').toLowerCase();
      if (v.indexOf('custom') !== -1) hasCustomOption = true;
    });
    var show = alwaysShow || hasCustomOption;
    box.hidden = !show;
    box.querySelectorAll('input').forEach(function(i){
      i.disabled = !show;
      if (!show) i.value = '';
    });
  }
  syncCustomText();

  // Quantity stepper
  var qty = document.getElementById('qty');
  if (qty){
    var minus = document.getElementById('qtyMinus');
    var plus  = document.getElementById('qtyPlus');
    if (minus) minus.addEventListener('click', function(){ qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); qty.dispatchEvent(new Event('change')); });
    if (plus)  plus.addEventListener('click',  function(){ qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); qty.dispatchEvent(new Event('change')); });
  }

  // Variant selector — keeps a hidden input synced and updates URL
  var optionRows = document.querySelectorAll('[data-option-row]');
  var variantInput = document.querySelector('input[name="id"]');
  var productJsonEl = document.getElementById('product-json');
  var productData = null;
  if (productJsonEl){
    try { productData = JSON.parse(productJsonEl.textContent); } catch(e){}
  }
  function getSelectedOptions(){
    var sel = [];
    optionRows.forEach(function(row){
      var btn = row.querySelector('.chip.is-active');
      sel.push(btn ? btn.getAttribute('data-value') : null);
    });
    return sel;
  }
  function findVariant(opts){
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function(v){
      return v.options.every(function(o, idx){ return o === opts[idx]; });
    });
  }
  function updateVariant(){
    var opts = getSelectedOptions();
    var v = findVariant(opts);
    if (v && variantInput){
      variantInput.value = v.id;
      var priceEl = document.getElementById('priceMain');
      if (priceEl && v.price != null){
        priceEl.textContent = (window.shopCurrency === 'USD' ? '$' : '') + (v.price / 100).toFixed(2);
      }
      var stockEl = document.querySelector('.stock');
      if (stockEl){
        if (v.available){ stockEl.textContent = 'In stock'; stockEl.classList.remove('sold-out'); }
        else { stockEl.textContent = 'Sold out'; stockEl.classList.add('sold-out'); }
      }
      var addBtn = document.getElementById('addToCart');
      if (addBtn) addBtn.disabled = !v.available;
    }
  }
  optionRows.forEach(function(row){
    row.addEventListener('click', function(e){
      var btn = e.target.closest('.chip');
      if (!btn || btn.disabled) return;
      row.querySelectorAll('.chip').forEach(function(c){ c.classList.remove('is-active'); c.setAttribute('aria-checked','false'); });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked','true');
      var sel = row.querySelector('.selected');
      if (sel) sel.textContent = btn.getAttribute('data-value');
      updateVariant();
      syncCustomText();
    });
  });
  if (productData) updateVariant();
  syncCustomText();
})();
